/**
 * The rail body's active tab (fix D / R3). Exactly ONE of these is mounted at a
 * time — the tabs that are not on screen do not exist in the tree, so a socket
 * message cannot re-render a standings table that nobody is looking at (UX spec
 * §1 rule 3, the same rule the rail-state bodies follow).
 *
 * `LiveBody` keeps M1a's `React.lazy` chunk (moved here from `rail/Rail/View`,
 * not a new boundary): the Suspense fallback it needs is the rail's own.
 */
import React from 'react';

import InfoPanel from '../../info/InfoPanel';
import {TabBodyModel} from './model';

const LiveBody = React.lazy(() => import('../../live/LiveBody'));
// The tournament panels wrap the OLD `CCTournaments` components, whose import
// closure reaches `@/navigators/StackConstants` (= every screen, including this
// one). Keeping them behind lazy boundaries keeps that cycle out of the rail's
// evaluation graph (crash 2026-10-05) and out of the casual game's chunk.
const DetailsPanel = React.lazy(
  () => import('../../tournament/panels/DetailsPanel'),
);
const StandingsPanel = React.lazy(
  () => import('../../tournament/panels/StandingsPanel'),
);
const PairingsPanel = React.lazy(
  () => import('../../tournament/panels/PairingsPanel'),
);
const LeaderboardPanel = React.lazy(
  () => import('../../tournament/panels/LeaderboardPanel'),
);

export default React.memo(function TabBodyView({tab}: TabBodyModel) {
  switch (tab) {
    case 'info':
      return <InfoPanel />;
    case 'details':
      return <DetailsPanel />;
    case 'standings':
      return <StandingsPanel />;
    case 'pairings':
      return <PairingsPanel />;
    case 'leaderboard':
      return <LeaderboardPanel />;
    default:
      return <LiveBody />;
  }
});
